<template>
    <i :class="icon" v-if="type === 'faIcon'"></i>
</template>

<script>
import { defineComponent } from 'vue'



export default defineComponent({
    props: {
        type:{
            type: String,
            default: "faIcon"
        },
        icon: {
            type: String,
            required: true
        }
    }
})
</script>
